import { UserProfile } from 'fitbeat.gym-core';
import {
    AssessmentQuestion,
    progressUpdate,
    ScanProgress,
    UnitPref,
} from 'fitbeat.models';
import moment from 'moment';
import {
    REQUEST_CONTINUE_TO_SET_TARGET,
    REQUEST_CONTINUE_TO_SET_TARGET_SUCCESS,
    REQUEST_CONTINUE_TO_SET_TARGET_FAILURE,
    LOAD_CHANGE_TARGET_SCREEN_SUCCESS,
} from '../WeightTarget/actionTypes';
import { LOGOUT } from './../utils';
import {
    BODY_SCALE_CAPTURE_METRIC_INFO,
    BODY_SCALE_ERROR,
    BODY_SCALE_ONBOARDING_START,
    BODY_SCALE_PROGRESS_UPDATE,
    BODY_SCALE_SCAN_START,
    DISCARD_BODY_SCALE_SCAN,
    NEXT_BODY_ASSESSMENT_QUESTION,
    PREVIOUS_BODY_ASSESSMENT_QUESTION,
    REMOVE_SCALE_FAILURE,
    REMOVE_SCALE_REQUEST,
    REMOVE_SCALE_SUCCESS,
    REQUEST_BODY_SCALE_SCAN_STATS,
    REQUEST_BODY_SCALE_SCAN_STATS_SUCCESS,
    REQUEST_FAILED,
    REQUEST_OVERRIDE_BODY_COMPOSITION_AND_CONDITIONING,
    REQUEST_OVERRIDE_BODY_COMPOSITION_AND_CONDITIONING_SUCCESS,
    REQUEST_SAVE_BODY_ASSESSMENT,
    REQUEST_SAVE_BODY_ASSESSMENT_SUCCESS,
    REQUEST_SAVE_BODY_SCALE_SCAN,
    REQUEST_SAVE_BODY_SCALE_SCAN_SUCCESS,
    SET_BODY_ASSESSMENT_ANSWER,
    SET_IS_SCAN_CONTINUING_FROM_WEIGHT_TARGET,
    SET_SCAN_PROGRESS,
    SET_TESTING_STUB,
    SHOW_BODY_TYPE_OPTIONS,
} from './actionTypes';
import {
    BODY_SHAPE,
    getBodyAssessmentQuestions,
    PICKUP_MASS_EASILY,
    SHOULDERS_WIDER_THAN_HIPS,
    WEIGHT_PATTERN,
    WHAT_SHAPE_YOUR_IN, WHATS_YOUR_DATE_OF_BIRTH,
    WHATS_YOUR_GENDER, WHATS_YOUR_HEIGHT,
    WHATS_YOUR_UNIT_PREF, WRIST_ENCIRCLE,
} from './assessmentQuestionnair';


const initialState = {
    view: {
        progress: null,
        phase: null,
        error: null,
        isSaving: null,
        useTestingStub: false,
        hasMetricInfo: null,
        hasBodyAssessment: null,
        hasBodyComposition: null,
        from: null,
        isScanContinuingFromWeightTarget: false,
        isReviewingTargetAndSavingScan: false,
        isRemovingBodyScale: false,
    },
    data: {
        rawScan: null,
        scaleScanStats: null,
        metrics: null,
        bodyAssessment: {
            questionsAndAnswers: getBodyAssessmentQuestions(),
            currentQuestion: null,
            currentQuestionAnswers: null,
            error: null,
            results: {},
            composition: null,
        },
    },
};

export default (
    state = initialState,
    action: { type: any; payload: any; }) => {
    switch (action.type) {
        case SET_SCAN_PROGRESS: {
            const progress = action.payload.progress;
            let from = null;
            if (progress !== ScanProgress.OverrideBodyType) {
                from = progress;
            }

            return {
                view: {
                    ...state.view,
                    progress,
                    from,
                },
                data: {
                    ...state.data,
                },
            };
        }
        case SHOW_BODY_TYPE_OPTIONS: {
            const from = state.view.progress;
            const progress = ScanProgress.OverrideBodyType;

            return {
                view: {
                    ...state.view,
                    progress,
                    from,
                },
                data: {
                    ...state.data,
                },
            };
        }
        case BODY_SCALE_ONBOARDING_START: {
            const progress = ScanProgress.Onboarding;

            return {
                view: {
                    ...state.view,
                    progress,
                },
                data: {
                    ...state.data,
                },
            };
        }

        case REQUEST_BODY_SCALE_SCAN_STATS: {
            const rawScan = action.payload.rawScan;
            const progress = ScanProgress.Inprogress;
            const phase = 'calculating';

            return {
                view: {
                    ...state.view,
                    progress,
                    phase,
                },
                data: {
                    ...state.data,
                    rawScan,
                },
            };
        }
        case REQUEST_BODY_SCALE_SCAN_STATS_SUCCESS: {
            const scaleScanStats = action.payload.scaleScanStats;
            const progress = ScanProgress.Complete;
            const phase = '';

            return {
                view: {
                    ...state.view,
                    progress,
                    phase,
                },
                data: {
                    ...state.data,
                    scaleScanStats,
                },
            };
        }
        case SET_TESTING_STUB: {
            const useTestingStub = action.payload.useTestingStub;
            return {
                view: {
                    ...state.view,
                    useTestingStub,
                },
                data: {
                    ...state.data,
                },
            };
        }
        case BODY_SCALE_SCAN_START: {
            const userProfile = action.payload.userProfile;
            const hasMetricInfo = hasAllUserMetrics(userProfile);
            const metrics = getUserMetrics(userProfile);
            const hasBodyAssessment = UserProfile.hasBodyAssessment(userProfile);
            const hasBodyComposition = UserProfile.hasBodyComposition(userProfile);
            const progress = state.view.progress === ScanProgress.AssessmentResults ?
            state.view.progress : ScanProgress.BeforeScan;
            let composition;
            let bodyAssessmentResults = {};
            if (hasBodyComposition) {
                composition = userProfile.bodyComposition;
                bodyAssessmentResults = userProfile.bodyAssessment;
            }

            return {
                view: {
                    ...state.view,
                    isSaving: false,
                    progress,
                    hasMetricInfo,
                    hasBodyAssessment,
                    hasBodyComposition,
                },
                data: {
                    ...state.data,
                    metrics,
                    bodyAssessment: {
                        ...state.data.bodyAssessment,
                        results: bodyAssessmentResults,
                        composition,
                    },
                },
            };
        }
        case REQUEST_SAVE_BODY_SCALE_SCAN: {
            return {
                view: {
                    ...state.view,
                    isReviewingTargetAndSavingScan: true,
                },
                data: {
                    ...state.data,
                },
            };
        }
        case REQUEST_SAVE_BODY_SCALE_SCAN_SUCCESS: {
            const progress = action.payload.shouldResetBodySacle ? ScanProgress.BeforeScan : state.view.progress;

            return {
                view: {
                    ...state.view,
                    progress,
                    isReviewingTargetAndSavingScan: false,
                },
                data: {
                    ...state.data,
                },
            };
        }
        case DISCARD_BODY_SCALE_SCAN: {
            const progress = ScanProgress.BeforeScan;

            return {
                view: {
                    ...state.view,
                    isSaving: false,
                    progress,
                },
                data: {
                    ...state.data,
                },
            };
        }
        case REQUEST_FAILED: {
            const error = action.payload.error;
            return {
                view: {
                    ...state.view,
                    isSaving: false,
                    error,
                    isReviewingTargetAndSavingScan: false,
                },
                data: {
                    ...state.data,
                },
            };
        }
        case BODY_SCALE_ERROR: {
            const error = action.payload.error;
            const progress = ScanProgress.Error;
            return {
                view: {
                    ...state.view,
                    progress,
                    error,
                },
                data: {
                    ...state.data,
                },
            };
        }
        case BODY_SCALE_PROGRESS_UPDATE: {
            const scaleStage = action.payload.stage;
            const { progress, phase } = progressUpdate[scaleStage];

            return {
                view: {
                    ...state.view,
                    progress,
                    phase,
                },
                data: {
                    ...state.data,
                },
            };
        }
        case BODY_SCALE_CAPTURE_METRIC_INFO: {
            const userProfile = action.payload.userProfile;
            const progress = ScanProgress.CaptureMetrics;
            const questionsAndAnswers = state.data.bodyAssessment.questionsAndAnswers;
            const hasBodyAssessment = UserProfile.hasBodyAssessment(userProfile);

            questionsAndAnswers.map((question) => {
                question.isCurrent = false;
                if (question.questionId === WHATS_YOUR_DATE_OF_BIRTH) {
                    const ddmmyyyy = userProfile.dateOfBirth ?
                        moment(userProfile.dateOfBirth, 'YYYY-MM-DD').format('DD-MM-YYYY') : '';
                    question.answer = ddmmyyyy;
                }

                if (question.questionId === WHATS_YOUR_UNIT_PREF) {
                    question.answer = userProfile.useImperialUnit ? UnitPref.imperial : UnitPref.metric;
                }

                if (question.questionId === WHATS_YOUR_HEIGHT) {
                    question.answer = userProfile.height ? userProfile.height.toString() : '';
                }
                if (question.questionId === WHATS_YOUR_GENDER) {
                    question.answer = userProfile.gender ? userProfile.gender : '';
                }

                if (hasBodyAssessment) {
                    if (question.questionId === WHAT_SHAPE_YOUR_IN) {
                        question.answer = userProfile.bodyAssessment.athleteMode;
                    }
                    if (question.questionId === PICKUP_MASS_EASILY) {
                        question.answer = userProfile.bodyAssessment.pickUpMassEasily;
                    }
                    if (question.questionId === SHOULDERS_WIDER_THAN_HIPS) {
                        question.answer = userProfile.bodyAssessment.shouldersWiderThanHips;
                    }
                    if (question.questionId === WRIST_ENCIRCLE) {
                        question.answer = userProfile.bodyAssessment.wristEncircle;
                    }

                    // new ones
                    if (question.questionId === WEIGHT_PATTERN) {
                        question.answer = userProfile.bodyAssessment.weightPattern;
                    }
                    if (question.questionId === BODY_SHAPE) {
                        question.answer = userProfile.bodyAssessment.bodyShape;
                    }

                }
            });

            const filteredQuestionsAndAnswers = questionsAndAnswers.filter((question) => {
                if ((question.questionId === WHATS_YOUR_DATE_OF_BIRTH ||
                    question.questionId === WHATS_YOUR_HEIGHT ||
                    question.questionId === WHATS_YOUR_GENDER ||
                    question.questionId === WHATS_YOUR_UNIT_PREF)
                    && question.answer !== '') {
                    return false;
                }
                return true;
            });

            const firstQuestion = filteredQuestionsAndAnswers[0];
            firstQuestion.isFirstQuestion = true;
            firstQuestion.isCurrent = true;
            Object.assign([], filteredQuestionsAndAnswers, { 0: firstQuestion });

            const currentQuestion = filteredQuestionsAndAnswers
                .find((question: AssessmentQuestion) => question.isCurrent === true);
            const currentQuestionAnswers = currentQuestion && currentQuestion.answersAndQuestionFlow;

            return {
                view: {
                    ...state.view,
                    progress,
                },
                data: {
                    ...state.data,
                    bodyAssessment: {
                        ...state.data.bodyAssessment,
                        questionsAndAnswers: filteredQuestionsAndAnswers,
                        currentQuestion,
                        currentQuestionAnswers,
                    },
                },
            };
        }
        case SET_BODY_ASSESSMENT_ANSWER: {
            const answer = action.payload.answer;
            const questionsAndAnswers = state.data.bodyAssessment.questionsAndAnswers;
            let currentQuestion: any = questionsAndAnswers
                .find((question: AssessmentQuestion) => question.isCurrent === true);
            currentQuestion = currentQuestion && { ...currentQuestion, answer };

            return {
                view: {
                    ...state.view,
                },
                data: {
                    ...state.data,
                    bodyAssessment: {
                        ...state.data.bodyAssessment,
                        currentQuestion,
                    },
                },
            };
        }
        case NEXT_BODY_ASSESSMENT_QUESTION: {
            let answer;
            const currentSetAnswer: any = state.data.bodyAssessment.currentQuestion;
            if (currentSetAnswer) {
                answer = currentSetAnswer.answer;
            }

            let currentQuestionAnswers: any = state.data.bodyAssessment.currentQuestionAnswers;
            const questionsAndAnswers = state.data.bodyAssessment.questionsAndAnswers;
            let currentQuestion: any = questionsAndAnswers
                .find((question: AssessmentQuestion) => question.isCurrent === true);

            if (!currentQuestion) {
                currentQuestion = state.data.bodyAssessment.currentQuestion;
            }

            const nextQuestion = questionsAndAnswers[questionsAndAnswers.indexOf(currentQuestion) + 1];
            const nextQ = nextQuestion ? nextQuestion : currentQuestion;
            if (nextQ) {
                questionsAndAnswers.map((question: any) => {
                    if (question.isCurrent === true) {
                        question.isCurrent = false;
                        question.answer = answer;
                    }
                    if (question.questionId === nextQ.questionId) {
                        question.isCurrent = true;
                        currentQuestion = question;
                        currentQuestionAnswers = question.answersAndQuestionFlow;
                    }
                });
            }

            let metrics: any = state.data.metrics;
            if (currentQuestion.isLastQuestion) {
                metrics = getMetricAnswerResults(metrics, questionsAndAnswers);
            }

            return {
                view: {
                    ...state.view,
                },
                data: {
                    ...state.data,
                    metrics,
                    bodyAssessment: {
                        ...state.data.bodyAssessment,
                        questionsAndAnswers,
                        currentQuestion,
                        currentQuestionAnswers,
                    },
                },
            };
        }

        case PREVIOUS_BODY_ASSESSMENT_QUESTION: {
            let answer = '';
            const currentSetAnswer: any = state.data.bodyAssessment.currentQuestion;
            if (currentSetAnswer) {
                answer = currentSetAnswer.answer;
            }
            let currentQuestionAnswers: any = state.data.bodyAssessment.currentQuestionAnswers;
            const questionsAndAnswers = state.data.bodyAssessment.questionsAndAnswers;
            let currentQuestion: any = questionsAndAnswers
                .find((question: AssessmentQuestion) => question.isCurrent === true);
            if (!currentQuestion) {
                currentQuestion = state.data.bodyAssessment.currentQuestion;
            }
            const previousQuestion = questionsAndAnswers[questionsAndAnswers.indexOf(currentQuestion) - 1];
            const prevQ = previousQuestion ? previousQuestion : currentQuestion;
            if (prevQ) {
                questionsAndAnswers.map((question: any) => {
                    if (question.isCurrent === true) {
                        question.isCurrent = false;
                        question.answer = answer;
                    }
                    if (question.questionId === prevQ.questionId) {
                        question.isCurrent = true;
                        currentQuestion = question;
                        currentQuestionAnswers = question.answersAndQuestionFlow;
                    }
                });
            }

            return {
                view: {
                    ...state.view,
                },
                data: {
                    ...state.data,
                    bodyAssessment: {
                        ...state.data.bodyAssessment,
                        questionsAndAnswers,
                        currentQuestion,
                        currentQuestionAnswers,
                    },
                },
            };
        }
        case REQUEST_SAVE_BODY_ASSESSMENT: {
            const questionsAndAnswers = state.data.bodyAssessment.questionsAndAnswers;
            const bodyAssessmentResults = getbodyAssessmentResults(questionsAndAnswers);

            return {
                view: {
                    ...state.view,
                    isSaving: true,
                },
                data: {
                    ...state.data,
                    bodyAssessment: {
                        ...state.data.bodyAssessment,
                        results: bodyAssessmentResults,
                    },
                },
            };
        }
        case REQUEST_SAVE_BODY_ASSESSMENT_SUCCESS: {
            const composition = action.payload.composition;
            return {
                view: {
                    ...state.view,
                    isSaving: false,
                    hasBodyAssessment: true,
                    hasBodyComposition: true,
                },
                data: {
                    ...state.data,
                    bodyAssessment: {
                        ...state.data.bodyAssessment,
                        composition,
                    },
                },
            };
        }
        case REQUEST_OVERRIDE_BODY_COMPOSITION_AND_CONDITIONING: {
            return {
                view: {
                    ...state.view,
                    isSaving: true,
                },
                data: {
                    ...state.data,
                },
            };
        }
        case REQUEST_OVERRIDE_BODY_COMPOSITION_AND_CONDITIONING_SUCCESS: {
            const {composition, athleteMode} = action.payload;
            return {
                view: {
                    ...state.view,
                    isSaving: false,
                },
                data: {
                    ...state.data,
                    bodyAssessment: {
                        ...state.data.bodyAssessment,
                        results : {
                            ...state.data.bodyAssessment.results,
                            athleteMode,
                        },
                        composition,
                    },
                },
            };
        }
        case LOGOUT: {
            return {
                view: {
                    ...state.view,
                },
                data: {
                    ...state.data,
                    bodyAssessment: {
                        ...state.data.bodyAssessment,
                        questionsAndAnswers: getBodyAssessmentQuestions(),
                    },
                },
            };
        }
        case SET_IS_SCAN_CONTINUING_FROM_WEIGHT_TARGET: {
            return {
                view: {
                    ...state.view,
                    isScanContinuingFromWeightTarget: action.payload.isScanContinuingFromWeightTarget,
                },
                data: {
                    ...state.data,
                },
            };
        }
        case REQUEST_CONTINUE_TO_SET_TARGET: {
            return {
                view: {
                    ...state.view,
                    isReviewingTargetAndSavingScan: true,
                },
                data: {
                    ...state.data,
                },
            };
        }
        case REQUEST_CONTINUE_TO_SET_TARGET_SUCCESS: {
            return {
                view: {
                    ...state.view,
                    isReviewingTargetAndSavingScan: false,
                },
                data: {
                    ...state.data,
                },
            };
        }
        case REQUEST_CONTINUE_TO_SET_TARGET_FAILURE: {
            return {
                view: {
                    ...state.view,
                    isReviewingTargetAndSavingScan: false,
                },
                data: {
                    ...state.data,
                },
            };
        }
        case LOAD_CHANGE_TARGET_SCREEN_SUCCESS: {
          const scaleScanStats = action.payload.bodyScaleScanStats;

          return {
              view: {
                ...state.view,
              },
              data: {
                ...state.data,
                scaleScanStats,
              },
          };
        }
        case REMOVE_SCALE_REQUEST: {
            return {
                view: {
                  ...state.view,
                  isRemovingBodyScale: true,
                },
                data: {
                  ...state.data,
                },
            };
        }
        case REMOVE_SCALE_SUCCESS: {
            return {
                view: {
                  ...state.view,
                  isRemovingBodyScale: false,
                },
                data: {
                  ...state.data,
                },
            };
        }
        case REMOVE_SCALE_FAILURE: {
            return {
                view: {
                  ...state.view,
                  isRemovingBodyScale: false,
                },
                data: {
                  ...state.data,
                },
            };
        }
        default:
            return state;
    }
};

const hasAllUserMetrics = (userProfile: UserProfile) => {
    return !!(userProfile.dateOfBirth &&
        userProfile.gender &&
        userProfile.height);
};

const getUserMetrics = (userProfile: UserProfile) => {
    const yyyymmdd = userProfile.dateOfBirth ? moment(userProfile.dateOfBirth).format('YYYY-MM-DD') : '';
    const ddmmyyyy = userProfile.dateOfBirth ? moment(userProfile.dateOfBirth, 'YYYY-MM-DD').format('DD-MM-YYYY') : '';
    const age = userProfile.age && userProfile.age;
    const height = userProfile.height && parseFloat(userProfile.height.toString());
    const gender = userProfile.gender && userProfile.gender;
    const useImperialUnit = userProfile.useImperialUnit || false;

    return {
        userProfileDob: yyyymmdd,
        dateOfBirth: ddmmyyyy,
        age,
        height,
        gender,
        useImperialUnit,
    };
};

const getMetricAnswerResults = (current, questionsAndAnswers: AssessmentQuestion[]) => {
    const dobQuestion = questionsAndAnswers.find((x) => x.questionId === WHATS_YOUR_DATE_OF_BIRTH);
    const dateOfBirth = dobQuestion ? new Date(dobQuestion.answer) : current.dateOfBirth;
    const yyyymmdd = moment(dateOfBirth, 'YYYY-MM-DD', true).isValid() ?
        dateOfBirth && moment(dateOfBirth, 'YYYY-MM-DD').format('YYYY-MM-DD') :
        dateOfBirth && moment(dateOfBirth, 'DD-MM-YYYY').format('YYYY-MM-DD');
    const ddmmyyyy = moment(dateOfBirth, 'YYYY-MM-DD', true).isValid() ?
        dateOfBirth && moment(dateOfBirth, 'YYYY-MM-DD').format('DD-MM-YYYY') :
        dateOfBirth && moment(dateOfBirth, 'DD-MM-YYYY').format('DD-MM-YYYY');

    const unitPref = questionsAndAnswers.find((x) => x.questionId === WHATS_YOUR_UNIT_PREF);
    const unitPrefAns = unitPref && unitPref.answer;
    const useImperialUnit = !unitPrefAns ? current.useImperialUnit : unitPrefAns;
    const heightQuestion = questionsAndAnswers.find((x) => x.questionId === WHATS_YOUR_HEIGHT);
    const height = heightQuestion ? parseFloat(heightQuestion.answer) : current.height;
    const genderQuestion = questionsAndAnswers.find((x) => x.questionId === WHATS_YOUR_GENDER);
    const gender = genderQuestion ? genderQuestion.answer : current.gender;

    return {
        userProfileDob: yyyymmdd,
        dateOfBirth: ddmmyyyy,
        useImperialUnit,
        height,
        gender,
    };
};

const getbodyAssessmentResults = (questionsAndAnswers: AssessmentQuestion[]) => {
    return questionsAndAnswers.some((x) => x.questionId === BODY_SHAPE) ? {
        athleteMode: questionsAndAnswers
            .find((x) => x.questionId === WHAT_SHAPE_YOUR_IN)!.answer,
        weightPattern: questionsAndAnswers
            .find((x) => x.questionId === WEIGHT_PATTERN)!.answer,
        shouldersWiderThanHips: questionsAndAnswers
            .find((x) => x.questionId === SHOULDERS_WIDER_THAN_HIPS)!.answer,
        bodyShape: questionsAndAnswers
            .find((x) => x.questionId === BODY_SHAPE)!.answer,
        wristEncircle: questionsAndAnswers
            .find((x) => x.questionId === WRIST_ENCIRCLE)!.answer,
    } : {
        athleteMode: questionsAndAnswers
            .find((x) => x.questionId === WHAT_SHAPE_YOUR_IN)!.answer,
        pickUpMassEasily: questionsAndAnswers
            .find((x) => x.questionId === PICKUP_MASS_EASILY)!.answer,
        shouldersWiderThanHips: questionsAndAnswers
            .find((x) => x.questionId === SHOULDERS_WIDER_THAN_HIPS)!.answer,
        wristEncircle: questionsAndAnswers
            .find((x) => x.questionId === WRIST_ENCIRCLE)!.answer,
    };
};
